"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgAudio = function (_a) {
    var primaryColor = _a.primaryColor, secondaryColor = _a.secondaryColor, tertiaryColor = _a.tertiaryColor, props = __rest(_a, ["primaryColor", "secondaryColor", "tertiaryColor"]);
    return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 10 9" }, props),
        react_1.default.createElement("path", { fill: primaryColor, fillRule: "evenodd", d: "M5.871.978a1.086 1.086 0 0 0-1.086.087l-.002.001-2.749 1.931h-.948A1.086 1.086 0 0 0 0 4.083v1.423a1.086 1.086 0 0 0 1.086 1.086h.946l2.683 1.929.006.004a1.086 1.086 0 0 0 1.082.088 1.086 1.086 0 0 0 .637-.965V1.953a1.086 1.086 0 0 0-.569-.975ZM2.528 6.025 5.15 7.91a.336.336 0 0 0 .334.026l.008-.004a.336.336 0 0 0 .198-.296V1.941a.336.336 0 0 0-.155-.292.336.336 0 0 0-.323.032L2.528 3.567v2.458Zm-1.68-2.18a.336.336 0 0 1 .238-.098h.692v2.095h-.692a.336.336 0 0 1-.336-.336V4.083c0-.089.035-.174.098-.237Zm7.823-1.473a.375.375 0 0 1 .528.05 3.49 3.49 0 0 1 .798 2.384 5.297 5.297 0 0 1-.766 2.673.375.375 0 0 1-.641-.389 4.55 4.55 0 0 0 .657-2.3v-.013A2.74 2.74 0 0 0 8.622 2.9a.375.375 0 0 1 .05-.528Zm-.894 1.117a.375.375 0 1 0-.578.478 1.183 1.183 0 0 1 .27.846c.014.294-.082.583-.27.81a.375.375 0 1 0 .578.478c.303-.367.46-.832.442-1.306a1.933 1.933 0 0 0-.442-1.306Z", clipRule: "evenodd" })));
};
exports.default = SvgAudio;
